<!-- Main menu: una sola línea; si no entra, se desplaza con las flechas -->
<div class="navbar-container main-menu-content hm-carousel" [class.has-prev]="canScrollPrev" [class.has-next]="canScrollNext">
  <button type="button" class="hm-carousel__arrow hm-carousel__arrow--prev" *ngIf="canScrollPrev"
          (click)="scrollMenu(-1)" [attr.aria-label]="'COMMON.BUTTONS.BACK' | translate">
    <lucide-icon name="chevron-left" [size]="18"></lucide-icon>
  </button>

  <ul #menuList class="nav navbar-nav hm-carousel__list" id="main-menu-navigation" layout="horizontal" core-menu
      (scroll)="updateArrows()"></ul>

  <button type="button" class="hm-carousel__arrow hm-carousel__arrow--next" *ngIf="canScrollNext"
          (click)="scrollMenu(1)" [attr.aria-label]="'COMMON.BUTTONS.NEXT' | translate">
    <lucide-icon name="chevron-right" [size]="18"></lucide-icon>
  </button>
</div>
<!--/ Main menu -->
